import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { refreshCoverablesOnsaSelectorAtom } from '../atoms/refreshCoverablesOnsaSelectorAtom';
import type { AllCoverablesOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';

export const coverablesOnsaSelector = selector<AllCoverablesOnsaDTO>({
    key: 'coverablesOnsaSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        get(refreshCoverablesOnsaSelectorAtom);
        const isLoggedOn = get(isLoggedOnSelector);

        if (!jobNumber) {
            throw new Error('Invalid jobId');
        }
        if (!sessionId) {
            throw new Error('Invalid sessionId');
        }

        const coverables = await OnlineSalesUnauthenticated.getAllOnsaCoverables(
            jobNumber,
            sessionId,
            !isLoggedOn
        );
        return coverables;
    }
});
